
import * as yup from "yup";
import i18n from "../i18n";

const MAX_TEXT = 100;
const MAX_ISO_CODE = 5;

const MIN_TEXT = 2;
const MIN_ISO_CODE = 2;

export const channelSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom du canal est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim()
});

export const institutionSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom de l'institution est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
    acronyme: yup
        .string()
        .required(i18n.t("L'acronyme est requis"))
        .min(MIN_TEXT, i18n.t("L'acronyme doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("L'acronyme ne peut pas dépasser 100 caractères"))
        .trim(),
    iso_code: yup
        .string()
        .required(i18n.t("Le code ISO est requis"))
        .matches(/^[0-9]+$/, i18n.t("Le code ISO doit contenir uniquement des chiffres"))
        .min(MIN_ISO_CODE, i18n.t("Le code ISO doit contenir au moins 2 caractères"))
        .max(MAX_ISO_CODE, i18n.t("Le code ISO ne peut pas dépasser 5 caractères"))
        .trim(),
    default_currency_slug: yup
        .string()
        .nullable()
});

export const unitTypeSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom du type d'unité est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
});

export const unitSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom de l'unité est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
    institution_id: yup
        .string()
        .required(i18n.t("L'institution est requise")),
    unit_type_id: yup
        .string()
        .required(i18n.t("Le type d'unité est requis")),
});

export const positionSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le libellé de la fonction est requis"))
        .min(MIN_TEXT, i18n.t("Le libellé doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le libellé ne peut pas dépasser 100 caractères"))
        .trim(),
});

export const ruleSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom du rôle est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
    description: yup
        .string()
        .required(i18n.t("La description du rôle est requise"))
        .min(MIN_TEXT, i18n.t("La description doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("La description ne peut pas dépasser 100 caractères"))
        .trim(),
});

export const typeCompteSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom du type de compte est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
    description: yup
        .string()
        .nullable()
        .max(MAX_TEXT, i18n.t("La description ne peut pas dépasser 100 caractères"))
        .trim(),
});

export const categoryClientSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le libellé de la catégorie client est requis"))
        .min(MIN_TEXT, i18n.t("Le libellé doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le libellé ne peut pas dépasser 100 caractères"))
        .trim(),
    description: yup
        .string()
        .nullable()
        .max(MAX_TEXT, i18n.t("La description ne peut pas dépasser 100 caractères"))
        .trim(),
});

export const clientSchema = yup.object().shape({
    category_client_id: yup
        .string()
        .required(i18n.t("La catégorie de client est requise"))
        .trim(),
    account_type_id: yup
        .string()
        .required(i18n.t("Le type de compte est requis"))
        .trim(),
    //institution_id: yup
        //.string()
        //.required(i18n.t("L'institution est requise"))
        //.trim(),
    type_client: yup
        .string()
        .required(i18n.t("Le type de client est requis"))
        .trim(),
    number: yup
        .string()
        .required(i18n.t("Le numéro de compte est requis"))
        .matches(/^[0-9]+$/, i18n.t("Le numéro de compte doit contenir uniquement des chiffres"))
        .min(5, i18n.t("Le numéro de compte doit contenir au moins 5 chiffres"))
        .max(50, i18n.t("Le numéro de compte ne peut pas dépasser 50 chiffres"))
        .trim(),
    telephone: yup
        .array()
        .of(
            yup
                .string()
                .matches(/^[0-9+\-\s()]+$/, i18n.t("Le numéro de téléphone contient des caractères invalides"))
                .min(8, i18n.t("Chaque numéro de téléphone doit contenir au moins 8 caractères"))
                .max(20, i18n.t("Chaque numéro de téléphone ne peut pas dépasser 20 caractères"))
                .trim()
        )
        .min(1, i18n.t("Au moins un numéro de téléphone est requis"))
        .required(i18n.t("Le numéro de téléphone est requis")),
});

export const claimCategorySchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom de la catégorie de réclamation est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
});

export const claimObjectSchema = yup.object().shape({
    name: yup
        .string()
        .required(i18n.t("Le nom de l'objet de réclamation est requis"))
        .min(MIN_TEXT, i18n.t("Le nom doit contenir au moins 2 caractères"))
        .max(MAX_TEXT, i18n.t("Le nom ne peut pas dépasser 100 caractères"))
        .trim(),
    time_limit: yup
        .number()
        .transform((_, originalValue) => originalValue ? parseInt(originalValue) : null)
        .required(i18n.t("Le temps limite est requis"))
        .min(1, i18n.t("Le temps limite doit être supérieur à 0"))
        .max(1000, i18n.t("Le temps limite ne peut pas atteindre 1000"))
});
